const LineIcon = ({ color }) => (
  <span
    style={{
      backgroundColor: color,
      display: 'inline-block',
      width: '16px',
      height: '2px',
      margin: '7px 4px 7px',
      verticalAlign: 'middle'
    }}
  />
)

export default LineIcon
